import { apiClient } from "../services/apiClient";
import { ATP_API_URL } from "../config/apiConfig";

/**
 * Builds a documents array from *Path fields — same logic as mapRecord in entityListActions.
 */
const buildDocuments = (r) => {
  console.log("[buildDocuments] Raw path fields from record:", {
    aadharCardPath: r.aadharCardPath,
    panCardPath: r.panCardPath,
    partnershipDeedPath: r.partnershipDeedPath,
    aadharOfBothPartnersPath: r.aadharOfBothPartnersPath,
    certificateOfIncorporationPath: r.certificateOfIncorporationPath,
    directorPANPath: r.directorPANPath,
    directorAadharPath: r.directorAadharPath,
    msmeCertificatePath: r.msmeCertificatePath,
    utilityBillDocumentPath: r.utilityBillDocumentPath,
    passbookOrCancelledChequePath: r.passbookOrCancelledChequePath,
    uploadSignedFormPath: r.uploadSignedFormPath,
    gstList: r.gstList,
  });

  const docPathMap = [
    { key: "doc_aadhar", label: "Aadhar Card", path: r.aadharCardPath },
    { key: "doc_pan", label: "PAN Card", path: r.panCardPath },
    {
      key: "doc_partnershipDeed",
      label: "Partnership Deed",
      path: r.partnershipDeedPath,
    },
    {
      key: "doc_aadharBoth",
      label: "Aadhar of Both Partners",
      path: r.aadharOfBothPartnersPath,
    },
    {
      key: "doc_coi",
      label: "Certificate of Incorporation",
      path: r.certificateOfIncorporationPath,
    },
    { key: "doc_directorPan", label: "Director PAN", path: r.directorPANPath },
    {
      key: "doc_directorAadhar",
      label: "Director Aadhar",
      // API field is directorAadharPath (not directorAadharCardPath)
      path: r.directorAadharPath || "",
    },
    {
      key: "doc_msme_certificate",
      label: "MSME Certificate",
      path: r.msmeCertificatePath,
    },
    {
      key: "doc_utility_bill",
      label: "Utility Bill",
      path: r.utilityBillDocumentPath,
    },
    {
      key: "doc_bank_proof",
      label: "Passbook / Cancelled Cheque",
      path: r.passbookOrCancelledChequePath,
    },
    {
      key: "third_party_file",
      label: "Signed Form (Third Party)",
      path: r.uploadSignedFormPath,
    },
  ];

  const documents = docPathMap
    .filter((d) => d.path && d.path !== "string" && d.path !== "")
    .map((d) => ({
      key: d.key,
      documentName: d.label,
      files: [
        {
          isUploaded: true,
          fileName: d.path.split("\\").pop() || d.label,
          filePath: d.path,
        },
      ],
    }));

  console.log(
    "[buildDocuments] Non-GST docs built:",
    documents.map((d) => `${d.key} → ${d.files[0]?.fileName}`),
  );

  // GST certificate docs
  console.log("[buildDocuments] gstList raw:", r.gstList);
  (r.gstList || []).forEach((g, i) => {
    console.log(`[buildDocuments] GST[${i}]:`, {
      gstNumber: g.gstNumber,
      state: g.state,
      gstAddress: g.gstAddress,
      gstCertificatePath: g.gstCertificatePath,
    });
    const certPath =
      g.gstCertificatePath &&
      g.gstCertificatePath !== "string" &&
      g.gstCertificatePath !== ""
        ? g.gstCertificatePath
        : null;
    documents.push({
      key: `gst_file_${i}`,
      documentName: `GST Certificate — ${g.gstNumber || i + 1}`,
      files: certPath
        ? [
            {
              isUploaded: true,
              fileName: certPath.split("\\").pop() || "GST",
              filePath: certPath,
            },
          ]
        : [],
    });
    console.log(
      `[buildDocuments] GST[${i}] doc pushed: key=gst_file_${i}, certPath=${certPath || "NONE"}`,
    );
  });

  console.log(
    "[buildDocuments] Final documents array:",
    documents.map((d) => ({
      key: d.key,
      name: d.documentName,
      fileCount: d.files.length,
      fileName: d.files[0]?.fileName || "—",
    })),
  );

  return documents;
};

/**
 * Fetches existing KYC/entity data by onboardingId (entityPrimaryId).
 * Returns both the raw record and a pre-built documents array.
 *
 * @param {number} id - entityPrimaryId / onboardingId from URL
 * @returns {{ success: boolean, data: object|null, documents: Array, error?: string }}
 */
export const fetchKYCDetailsByIdAction = async (id) => {
  try {
    const body = {
      id,
      category: null,
      entityName: null,
      email: null,
      documentStatus: true,
      isVerified: false,
      pageNumber: 1,
      pageSize: 10,
    };

    const response = await apiClient.post(
      ATP_API_URL.GET_ALL_DATA_SEARCH,
      body,
    );
    console.log("[KYC Prefill] POST body:", body);
    console.log("[KYC Prefill] Response status:", response?.status);
    console.log(
      "[KYC Prefill] Response data type:",
      Array.isArray(response?.data) ? "array" : typeof response?.data,
    );
    console.log("[KYC Prefill] Response data:", response?.data);

    if (response?.status === 200 && response.data) {
      const rawData = response.data;
      const record = Array.isArray(rawData) ? rawData[0] : rawData?.data?.[0];

      console.log("[KYC Prefill] Parsed record:", record);
      console.log("[KYC Prefill] record.gstList:", record?.gstList);
      console.log(
        "[KYC Prefill] record.isGSTRegistered:",
        record?.isGSTRegistered,
      );

      if (!record) {
        console.log("[KYC Prefill] No record found for id:", id);
        return { success: false, data: null, documents: [] };
      }

      const documents = buildDocuments(record);
      console.log("[KYC Prefill] Built documents count:", documents.length);

      return {
        success: true,
        data: record,
        documents,
      };
    }

    return { success: false, data: null, documents: [] };
  } catch (error) {
    console.warn("[KYC Prefill] Error:", error.message);
    return { success: false, data: null, documents: [], error: error.message };
  }
};
